export type ITrick = {
    key: string;
    value: number;
}

const Tricks: { [key: string]: ITrick } = {

    /*------------ Backfips ---------------*/
    BACKFLIP: { key: 'backflip', value: 5 },
    DOUBLE_BACKFLIP: { key: 'double_backflip', value: 15 },
    TRIPPLE_BACKFLIP: { key: 'tripple_backflip', value: 30 },
    QUADRUPLE_BACKFLIP: { key: 'quadruple_backflip', value: 50 },

    /*----------- Frontflips -------------*/
    FRONTFLIP: { key: 'frontflip', value: 10 },
    DOUBLE_FRONTFLIP: { key: 'double_frontflip', value: 30 },
    TRIPPLE_FRONTFLIP: { key: 'tripple_frontflip', value: 60 },
    QUADRUPLE_FRONTFLIP: { key: 'quadruple_frontflip', value: 90 },

    /**------------ Others ---------------*/
    WHEELIE: { key: 'wheelie', value: 5 },
    ENDO: { key: 'endo', value: 5 },
    BIG_AIR: { key: 'big_air', value: 10 },
    PERFECT_LANDING: { key: 'perfect_landing', value: 5 }
}

export default Tricks